<template>
  <div>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="categoria.nome"
        placeholder="Nome"
        :state="validateState('nome')"
      />
      <b-form-text v-if="!!categoria.id">
        Para editar os dados de tradução do termo, clique em
        <b-button
          variant="link"
          size="sm"
          class="px-0"
          target="_blank"
          :to="{
            name: 'termos_filtros_edit',
            params: { id: categoria.id, tipo: 'categoria' },
          }"
        >
          editar tradução
          <font-awesome-icon icon="arrow-up-right-from-square" size="sm" />
        </b-button>
      </b-form-text>
      <b-form-invalid-feedback>
        Nome é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Descrição:">
      <b-form-textarea
        v-model="categoria.descricao"
        placeholder="Descrição"
      ></b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    categoria: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("categorias", ["categoria"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.categoria[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.categoria.$touch();
      return !this.$v.categoria.$anyError;
    },
  },
  created() {},
};
</script>
